import { gql } from 'graphql-request';

export default gql`query($filter: FilterInput) {
    luminaireConfigFilters(filter: $filter) {
        diode_current
        diode_max_current
        nominal_power_factor
        power_factor
        rank {
            id
            description
            label
            checked
            optional
        }
    }
}`;